module.exports = __webpack_public_path__ + "static/media/gallery16.46c7cefc.png";